<div class="slideshow">

    <div class="slideshow__content">

        {#each images as image, index (image.url)}

        <div class={slideshowItemClass(activeIndex, index)} style={slideshowItemStyle(image.url)}>

        </div>
    
        {/each}

    </div>

    {#if images.length > 1}

    <ul class="slideshow__navigation">

        {#each images as image, index (image.url)}

        <li on:click='set({activeIndex: index, switcharoo: !switcharoo})' class={slideshowNavigationItemClass(activeIndex, index)} title="{image.title}"></li>

        {/each}

    </ul>

    <div on:click='set({autoplay: !autoplay})' class="slideshow__autoplay {autoplay ? 'slideshow__autoplay--active' : ''}">

        <div class="slideshow__autoplay-disc">

            <LoadingDisc interval={interval} diameter="1.5rem" playing={autoplay ? true : false} switcharoo={switcharoo} />

        </div>

        <div class="slideshow__autoplay-icon">

            {#if autoplay}

            <Icon iconId="play3" />
    
            {:else}
    
            <Icon iconId="pause2" />
    
            {/if}

        </div>

    </div>

    {/if}

</div>

<style>

    .slideshow {
        position: relative;
        width: 100%;
        /* min-height: calc(100vw / 21 * 9);
        height: 100%; */
        height: 0;
        padding-bottom: calc(100% / 16 * 9);
    }

    @media screen and (min-width: 80rem) {
        .slideshow {
            min-height: inherit;
        }
    }

    .slideshow__content {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        overflow: hidden;
        top: 0;
        left: 0;
    }

    .slideshow__navigation {
        position: absolute;
        left: 0;
        bottom: 1rem;
        margin: 0;
        padding: 0;
        list-style: none;
        z-index: 2;
        width: 100%;
        text-align: center;
    }

    .slideshow__navigation-item {
        display: inline-block;
        width: 1rem;
        height: 1rem;
        background-color: var(--light);
        border-radius: 1rem;
        margin: 0 0.5rem;
        box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.25);
        cursor: pointer;
    }

    .slideshow__navigation-item.slideshow__navigation-item--active {
        background-color: var(--warning);
    }

    .slideshow__autoplay {
        position: absolute;
        left: 1rem;
        bottom: 1.25rem;
        margin: 0;
        padding: 0.25rem;
        list-style: none;
        z-index: 2;
        /* width: 100%; */
        text-align: center;
        background-color: var(--light);
        border-radius: 1rem;
        margin: 0 0.5rem;
        box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.25);
        width: 1.5rem;
        height: 1.5rem;
        line-height: 1rem;
        cursor: pointer;
        overflow: hidden;
    }

    .slideshow__autoplay-disc {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 0;
    }

    .slideshow__autoplay-icon {
        position: relative;
        z-index: 1;
    }

    .slideshow__item {
        position: absolute;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        top: 0;
        left: 100%;
        transition: left 150ms ease;
    }

    .slideshow__item--before {
        left: -100%;
    }

    .slideshow__item--active {
        left: 0;
    }    

    .slideshow__item--after {
        left: 100%;
    }

</style>

<script>
    import Icon from 'Icon.html'
    import LoadingDisc from 'LoadingDisc.html'

    let timeout = null

    export default {
        components: {
            Icon,
            LoadingDisc
        },
        helpers: {
            slideshowItemClass: (activeIndex, index) => {
                let classes = ['slideshow__item']

                if (index < activeIndex) classes.push('slideshow__item--before')

                if (index == activeIndex) classes.push('slideshow__item--active')

                if (index > activeIndex) classes.push('slideshow__item--after')

                return classes.filter(Boolean).join(' ')
            },
            slideshowNavigationItemClass: (activeIndex, index) => {
                let classes = ['slideshow__navigation-item']

                if (index == activeIndex) classes.push('slideshow__navigation-item--active')

                return classes.filter(Boolean).join(' ')
            },
            slideshowItemStyle: (backgroundImage) => {
                let styles = []

                if (backgroundImage) styles.push(`background-image: url(${backgroundImage});`)

                return styles.filter(Boolean).join(' ')
            },
        },
        oncreate() {
            const component = this
            const { autoplay, interval } = this.get()

            const nextSlide = () => {
                const switcharoo = !component.get().switcharoo

                if (component.get().activeIndex < component.get().images.length - 1) {
                    component.set({
                        switcharoo,
                        activeIndex: component.get().activeIndex + 1
                    })
                } else {
                    component.set({
                        switcharoo,
                        activeIndex: 0
                    })
                }
            }

            component.on('state', ({ changed, current, previous }) => {
                if (current.autoplay) {
                    clearTimeout(timeout)

                    timeout = setTimeout(nextSlide, current.interval)
                }

                if (!current.autoplay && timeout) {
                    clearTimeout(timeout)
                }
            })

            if (autoplay) {
                clearTimeout(timeout)

                timeout = setTimeout(nextSlide, interval)
            }
        },
        ondestroy() {
            clearTimeout(timeout)
        },
        data() {
            return {
                images: [],
                activeIndex: 0,
                switcharoo: false,
                autoplay: false,
                interval: 1000
            }
        }
    }
</script>